import { combineReducers } from 'redux';
import bundlesReducer from './bundlesSlice';
import r2FilesReducer from './r2FilesSlice';
import adminsReducer from './adminsSlice';

export default combineReducers({
  bundles: bundlesReducer,
  r2Files: r2FilesReducer,
  admins: adminsReducer
})
